import { Box, Typography, Alert } from "@mui/material";

// Rendered when the user authenticates successfully but lacks the
// role required for the requested feature (the admin pages route
// here on 403).

export function Forbidden() {
  return (
    <Box p={3} maxWidth={600}>
      <Alert severity="warning">
        <Typography variant="h6" gutterBottom>
          Forbidden
        </Typography>
        <Typography variant="body2">
          You're signed in, but this page requires the <code>paim-admin</code>{" "}
          group. Ask your Okta admin to add you, or use the user-level pages.
        </Typography>
      </Alert>
    </Box>
  );
}
